import React, { useState } from 'react';
import './App.css';
import DistributionBoard from './components/DistributionBoard';
import Facilities from './components/Facilities';
import ElectricalReference from './components/ElectricalReference';
import AssetQRGenerator from './components/AssetQRGenerator';

function App() {
  // 현재 선택된 탭 상태 관리
  const [selectedTab, setSelectedTab] = useState('distribution');
  
  // 탭 데이터
  const tabs = [
    { id: 'distribution', name: '분전반 정보' },
    { id: 'facilities', name: '시설물 현황' },
    { id: 'electrical', name: '전기 기술 자료' },
    { id: 'asset-qr', name: '자산관리 QR 생성' }
  ];
  
  // 탭 변경 이벤트 핸들러
  const handleTabChange = (tabId) => {
    console.log(`탭 변경: ${tabId}로 전환`);
    setSelectedTab(tabId);
  };
  
  return (
    <div className="app-container">
      <header className="app-header">
        <h1>롯데호텔월드</h1>
      </header>
      
      <div className="tabs-container">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${selectedTab === tab.id ? 'active' : ''}`}
            onClick={() => handleTabChange(tab.id)}
          >
            {tab.name}
          </button>
        ))}
      </div>
      
      <div className="content-area">
        {selectedTab === 'distribution' && <DistributionBoard />}
        {selectedTab === 'facilities' && <Facilities />}
        {selectedTab === 'electrical' && <ElectricalReference />}
        {selectedTab === 'asset-qr' && <AssetQRGenerator />}
      </div>
      
      <footer className="app-footer">
        <p>© 2025 롯데호텔월드</p>
      </footer>
    </div>
  );
}

export default App;